module.exports = __webpack_public_path__ + "img/xn.6b76367d.jpg";